import 'waypoints/lib/jquery.waypoints';

import Menu from './menu';
import config from '../config';

const { fixedHeaderPixels } = config;

export default class Header {
    constructor() {
        this.$header = $('.header');
        this.$body = $('body');
        this.init();
    }

    _createPlaceholder() {
        const fixedElHeight = this.$header.height();

        return $('<div />').css({
            height: fixedElHeight,
            position: /absolute|fixed/.test(this.$header.css('position')) ? 'absolute' : 'static'
        });
    }

    _fixedElement() {
        this.$placeholder = this._createPlaceholder();

        this.$header
                .addClass('is-fixed')
                .before(this.$placeholder);
    }

    _unFixedElement() {
        this.$header.removeClass('is-fixed');

        if (this.$placeholder && this.$placeholder.length) {
            this.$placeholder.remove();
            this.$placeholder = null;
        }
    }

    _bindHandlers() {
        this.$body.waypoint(direction => {
            direction === 'down' ?  this._fixedElement() : this._unFixedElement();
        }, {
            offset: -fixedHeaderPixels
        })
    }

    init() {
        this._bindHandlers();

        new Menu();
    }

}



// WEBPACK FOOTER //
// ./components/header.js